import React from 'react';

import { WalletButton } from '../../../TopNav/parts';
import { Toggle } from '../../Toggle';
import { Buttons, Collapse, Collapseable } from '../../styles';

export const WalletSection = () => {
    return (
        <Collapseable>
            <Toggle icon="wallet" isOpen={true} isStatic={true}>
                Wallets
            </Toggle>

            <Collapse>
                <Buttons>
                    <WalletButton mobileNav />
                </Buttons>
            </Collapse>
        </Collapseable>
    );
};
